module.exports = __webpack_public_path__ + "img/xpa.f2c7a064.svg";